import { ContentOnexOneRecipe, BtnListCollection } from "./styles";
import ContentImage from "@/shared/ContentImage";
import ContentTitle from "@/shared/ContentTitle";
import { NormalArticle } from "@/widgets/Nota/Templates/stylesModulesGenericNormal.js";
import { LinkAbsolute } from "@/shared/LinkAbsolute";
import { clickContent } from "@/shared/Analitics/GoogleAnalytics4";
import useNewsDataModules from "@/hooks/useNewsDataModules";
import FoodRanking from "@/shared/FoodRanking";
const OnexOneRecipe = (props) => {
  const clippings = {
    desktop: ["square_md"],
    mobile: ["square_md"],
  };

  if (props?.selectedClippingId) {
    clippings.desktop = [props.selectedClippingId, ...clippings.desktop];
    clippings.mobile = [props.selectedClippingId, ...clippings.mobile];
  }

  const {
    asPath,
    authors = [],
    authorSignature,
    children,
    containerName,
    cutTitle = false,
    iconMultimedia,
    image,
    imagePreview,
    imageWeb,
    isPreview,
    payWallExclusive,
    section = [],
    showDate = false,
    subtitle,
    title,
    url,
    urlTarget,
    features,
    tags,
    _id,
    id,
    summary,
    sections,
  } = useNewsDataModules(props, clippings);

  const noteDetail = { _id: _id ?? props.elementID, url }; // Se declara noteDetail para usarse en FootRanking
  let date = true;

  return (
    <NormalArticle>
      <ContentOnexOneRecipe
        className="onexonerecipe"
        id={_id ?? props.elementID}
      >
        <div className={"flip-card-container-" + (_id ?? props.elementID)}>
          <div className="flip-card-inner">
            {children}
            <ContentTitle
              type="onexonerecipe"
              section={sections}
              author={authors}
              authorSignature={authorSignature}
              title={title}
              subtitle={subtitle}
              payWallExclusive={payWallExclusive}
              date={date}
              dateHours={true}
              cutTitle={cutTitle}
              showDate={showDate}
              summary={summary}
              sections={sections}
              alwaysShowSectionName={true}
            />
            <FoodRanking
              elementID={props.elementID}
              tags={tags}
              features={features}
              noteDetail={noteDetail}
              isBorderNone={false} // En true Quita el borde punteado
              isColumnLayout={false} // En true cambia a direction columns
            />
            <picture>
              {isPreview ? (
                imagePreview && (
                  <ContentImage
                    iconMultimedia={iconMultimedia}
                    data={imagePreview}
                    alt={title}
                  />
                )
              ) : (
                <ContentImage
                  iconMultimedia={iconMultimedia}
                  data={imageWeb}
                  alt={title}
                  image={image}
                />
              )}
            </picture>
            <LinkAbsolute
              href={url}
              target={urlTarget}
              aria-label={title}
              onClick={() =>
                clickContent(
                  { contentType: title, contentList: containerName },
                  url,
                  asPath
                )
              }
              className="linkAbsolute"
            />
          </div>
        </div>
      </ContentOnexOneRecipe>
    </NormalArticle>
  );
};

export default OnexOneRecipe;
